import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export { CandoIcon, GoldenHorseshoeIcon, SilverCoinIcon } from '../bank/CurrencyIcons';

interface ResourceBarProps {
	color: string;
	value: number;
	icon: ReactNode;
	link?: string;
	showBackground?: boolean;
}

const formatNumber = (num: number): string => {
	return num.toLocaleString('de-DE');
};

export default function ResourceBar({ color, value, icon, link, showBackground = true }: ResourceBarProps) {
	const content = (
		<div className="flex items-center px-2 gap-1 lg:gap-2 w-full h-full">
			<div className="flex-shrink-0 flex items-center">{icon}</div>
			<div
				className={`font-regular ml-auto ${value < 0 ? 'text-red-600' : 'text-white'} text-sm flex items-center`}
			>
				{formatNumber(value)}
			</div>
		</div>
	);

	return (
		<div className="flex items-center h-full">
			<div
				className={`flex flex-grow h-8 ${showBackground ? 'wood-dark' : ''} rounded-r-lg drop-shadow-lg overflow-visible ${link ? 'cursor-pointer hover:brightness-110' : ''}`}
			>
				{link ? (
					<Link to={link} className="w-full">
						{content}
					</Link>
				) : (
					content
				)}
			</div>
		</div>
	);
}
